export enum TimeEntryRequiredFields {
	Activity = 'activity',
	Description = 'description',
}
